var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWithdrawal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/funds/icon-withdraw") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.2944681,12.8941176 L13.2944681,18.9025882 L11.1651064,18.9025882 C11.1191489,18.9025882 11.0731915,18.9371765 11.0578723,18.9865882 C11.0476596,19.0014118 11.0476596,19.0162353 11.0476596,19.0310588 C11.0476596,19.0656471 11.0578723,19.1002353 11.0834043,19.1249412 L14.9234043,23.0235294 C14.9693617,23.068 15.0357447,23.068 15.0817021,23.0235294 L18.9217021,19.1249412 C18.9421277,19.1002353 18.9574468,19.0656471 18.9574468,19.0310588 C18.9574468,19.0162353 18.9523404,19.0014118 18.947234,18.9865882 C18.9319149,18.9371765 18.8859574,18.9025882 18.84,18.9025882 L16.8587234,18.9025882 L16.8587234,12.8941176 L20.8774468,12.8941176 L20.8774468,25 L9.13276596,25 L9.13276596,12.8941176 L13.2944681,12.8941176 Z M23.9361702,4 C25.6314894,4 27,5.32917647 27,6.96470588 L27,16.3529412 C27,17.9884706 25.626383,19.3176471 23.9361702,19.3176471 L23.1702128,19.3176471 L23.1702128,13.3882353 C24.0178723,13.3882353 24.7021277,12.7261176 24.7021277,11.9058824 C24.7021277,11.0856471 24.0178723,10.4235294 23.1702128,10.4235294 L6.82978723,10.4235294 C5.98212766,10.4235294 5.29787234,11.0856471 5.29787234,11.9058824 C5.29787234,12.7261176 5.98212766,13.3882353 6.82978723,13.3882353 L6.82978723,19.3176471 L6.06382979,19.3176471 C4.37361702,19.3176471 3,17.9884706 3,16.3529412 L3,6.96470588 C3,5.32917647 4.37361702,4 6.06382979,4 Z M23.1906383,6.22352941 L20.1268085,6.22352941 C19.8459574,6.22352941 19.6161702,6.44588235 19.6161702,6.71764706 L19.6161702,8.2 C19.6161702,8.47176471 19.8459574,8.69411765 20.1268085,8.69411765 L23.1906383,8.69411765 C23.4714894,8.69411765 23.7012766,8.47176471 23.7012766,8.2 L23.7012766,6.71764706 C23.7012766,6.44588235 23.4714894,6.22352941 23.1906383,6.22352941 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.7%",
    y: "-9.5%",
    width: "133.3%",
    height: "138.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/funds/icon-withdraw",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "convert"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWithdrawal);
export default __webpack_public_path__ + "static/media/icon-withdrawal.98af29b740ac214c6f1461fac26562dd.svg";
export { ForwardRef as ReactComponent };